var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBucketCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88 16.49 6.49 14.1c-1.1-1.1-1.1-2.36 0-3.45l3.99-3.99a.75.75 0 0 1 1.06 0l4.39 4.39c.25.25.38.58.38.93 0 .35-.14.68-.39.93l-3.59 3.59c-.54.53-1.13.81-1.72.81-.59 0-1.18-.27-1.73-.82zM7.55 11.7c-.17.17-.38.43-.38.67 0 .24.21.49.38.67l2.39 2.39c.17.17.43.38.67.38.24 0 .49-.21.67-.38l3.46-3.46-3.73-3.73-3.46 3.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.48 7.71-.8-.8a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.8.8c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM5.71 12.36a.75.75 0 0 1 .72-.78l9.03-.39c.41-.03.76.3.78.72.02.42-.3.76-.72.78l-9.03.39h-.03a.75.75 0 0 1-.75-.72z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.621 16.1c0-.95 1-2.11 1.3-2.44.28-.31.82-.31 1.1 0 .3.33 1.3 1.49 1.3 2.44a1.84 1.84 0 0 1-1.85 1.85c-1.02 0-1.85-.83-1.85-1.85zm1.5 0c0 .19.16.35.35.35.19 0 .35-.16.35-.35.01-.13-.14-.41-.35-.72-.21.31-.35.59-.35.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBucketCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-bucket-circle.d6c49b9511a03775f77baf16279412bb.svg";
export { ForwardRef as ReactComponent };